
function _debounce(fn, delay=1000) {
    var timer
    return function() {
        var th = this
        if (timer) {
            clearTimeout(timer)
            timer = setTimeout(function() {
                timer = null
                fn.apply(th)
            }, delay)
        } else {
            timer = setTimeout(function() {
                fn.apply(th)
            }, 0)
        }
        
    }
}
const debounce = (Vue)=> {

    Vue.directive('debounce', {
        inserted(el, binding) {
            el.onclick = _debounce(binding.value,binding.arg)
        }
    })
}
export default debounce



//////////////////
// WEBPACK FOOTER
// ./node_modules/@mxc/v-directive/utils/debounce.js
// module id = null
// module chunks = 